import { render, staticRenderFns } from "./PayerInfo.vue?vue&type=template&id=3a48ebf2&scoped=true"
import script from "./PayerInfo.vue?vue&type=script&lang=js"
export * from "./PayerInfo.vue?vue&type=script&lang=js"
import style0 from "./PayerInfo.vue?vue&type=style&index=0&id=3a48ebf2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a48ebf2",
  null
  
)

export default component.exports